





























helpers = require('../../helpers.coffee')

view_model =
  props: ['contact']

  data: ->
    users: []
    user_options: []
    selected_user: {}
    current_user: Session.current_user
    current_company: Session.current_company

  methods:
    showUserOption: (user) ->
      if @current_user.isManager() || @current_user.isAdmin() || (@current_company.account_setting.seller_can_change_responsability && user.id == @current_user.id)
        true 
      else if @contact.user_id == @current_user.id
        true
      else
        false

    loadUsers: ->
      new UsersResource().index(@loadUsersSuccess, @unknownError)

    loadUsersSuccess: (data) ->
      users = data.users
      users.remove(@contact.user_id) if @contact.user_id
      @users = users

    openUpdateContactUserConfirmationModal: (user) ->
      @selected_user = user
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-update-contact-user'

    canUpdateContactUser: ->
      !@contact.active_on_flow && @isAllowedToUpdateContactUser()

    isAllowedToUpdateContactUser: ->
      Session.current_user.isAdmin() || 
      Session.current_user.isManager() || 
      Session.current_user.id == @contact.user_id || 
      (Session.current_user.isSeller() && Session.current_company.account_setting.seller_can_change_responsability)

    validateUpdateContactUser: ->
      errors = []
      errors.push('- Você não tem permissão para alterar o responsável desse contato') unless @isAllowedToUpdateContactUser()
      errors.push('- O contato deve estar inativo, finalizado ou conectado para alterar seu responsável') if @contact.active_on_flow
      if errors.length
        alertify.alert(errors.join('<br>'))
      else
        @updateUsersOptions()

    updateUsersOptions: ->
      @user_options = []
      for user in @users
        @user_options.push(user) if user.id != @contact.user_id

    updateContactUser: ->
      @$emit('update-contact', user_id: @selected_user.id)

  created: ->
    @loadUsers()

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/user_dropdown.vue